module.exports = __webpack_public_path__ + "img/curso_6_texto.624e70a3.png";